import logo from '../../../public/img/logos/DBQuestions_Icon.svg'
import Icon from '../icon/Icon'

export default function LoadingWithOutMessage() {
    return <Icon src={logo} alt={''} className="loading-animation h-2 w-2" />
}
